const VOLUNTEERS_UPDATED = (state, volunteers) => {
  state.volunteers = volunteers.data;
};

const PENDING_VOLUNTEERS_UPDATED = (state, volunteers) => {
  state.pendingVolunteers = volunteers.data;
};

const VOLUNTEER_UPDATED = (state, volunteer) => {
  state.volunteer = volunteer.data;
};

const VOLUNTEER_RESET = (state, volunteer) => {
  state.volunteer = null;
  state.volunteers.data = state.volunteers.data.filter(function(item) {
    return item.id != volunteer.id;
  });
};

const VOLUNTEER_RESET_ONLY = (state) => {
  state.volunteer = null;
}

export default {
  VOLUNTEERS_UPDATED,
  PENDING_VOLUNTEERS_UPDATED,
  VOLUNTEER_UPDATED,
  VOLUNTEER_RESET,
  VOLUNTEER_RESET_ONLY,
};
